import { TokenProvider } from '@fluidx/office-fluid-types';
import { DriverInfo } from '../DriverInfo';
import { prefetchOdcTokens, prefetchOdspTokens } from '../TokenPrefetch';

export function attemptTokenPrefetch(tokenProvider: TokenProvider, driverInfo: DriverInfo) {
  // Prefetching tokens for UnauthenticatedGuest user will not work because this access mode relies on
  // proof token flow where each hydrated Fluid document will have unique token.
  if (tokenProvider.identityType === 'UnauthenticatedGuest') {
    return;
  }

  // We can start making optimistic token fetches in parallel to the iframe loading to reduce end to end latency.
  // This assumes the host's token provider is capable of reusing in flight token requests to provide better performance.
  if (tokenProvider.identityType === 'Consumer') {
    prefetchOdcTokens(tokenProvider).catch(() => {});
  } else {
    prefetchOdspTokens(tokenProvider, [driverInfo.documentUrl]).catch(() => {});
  }
}

// cspell:ignore Odsp, prefetch
